/**
* FAQ JS
* -----------------------------------------------------------------------------
*
* All the JS for the FAQ component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

( function( app ) {
  const COMPONENT = {

    className: 'faq',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.faq__question-status, .faq__question-title' ).click( function() {
        if ( $( this ).closest( '.faq__question' ).hasClass( 'open' ) ) {
          $( this ).closest( '.faq__question' ).find( '.faq__question-answer' ).slideUp();
          $( this ).closest( '.faq__question' ).removeClass( 'open' );
        } else {
          $( '.faq__question.open .faq__question-answer' ).slideUp();
          $( '.faq__question' ).removeClass( 'open' );
          $( this ).closest( '.faq__question' ).find( '.faq__question-answer' ).slideDown();
          $( this ).closest( '.faq__question' ).addClass( 'open' );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'faq', COMPONENT );
} )( app );
